<template>
    <div class="page">
        <div class="page-bd">
            <div class="edit-box">
                <div class="mg-right10">
                    <Input v-model="search.org_from_cname">
                        <span slot="prepend">{{$t('org_from1_cname')}}{{$t('x_yd')}}</span>
                    </Input>
                </div>
                <div class="mg-right10">
                    <Input v-model="search.org_from2_cname">
                        <span slot="prepend">{{$t('org_from2_cname')}}{{$t('x_yd')}}</span>
                    </Input>
                </div>
                <div class="mg-right10">
                    <Input v-model="search.org_fr_cname">
                        <span slot="prepend">{{$t('org_cname')}}{{$t('x_yd')}}</span>
                    </Input>
                </div>
                <div class="mg-right10"><Button type="primary" @click="openAdd($t('curr_org'))">{{$t('add_sub')}}</Button></div>
                <div class="mg-right10"><Button type="primary" @click="list">{{$t('list')}}</Button></div>
            </div>
<!--            <div class="edit-box">-->
<!--                <div class="mg-right10">-->
<!--                    <Input v-model="search.min_money_amt_from" class="w150">-->
<!--                        <span slot="prepend">{{$t('from_yue_xd')}} {{$t('xy_dy')}}</span>-->
<!--                    </Input>-->
<!--                </div>-->
<!--                <div class="mg-right10">-->
<!--                    <Input v-model="search.min_money_amt_from2" class="w150">-->
<!--                        <span slot="prepend">{{$t('from2_yue_xd')}} {{$t('xy_dy')}}</span>-->
<!--                    </Input>-->
<!--                </div>-->
<!--                <div class="mg-right10">-->
<!--                    <Input v-model="search.min_money_amt_fr" class="w150">-->
<!--                        <span slot="prepend">{{$t('from3_yue_xd')}} {{$t('xy_dy')}}</span>-->
<!--                    </Input>-->
<!--                </div>-->
<!--                <div class="mg-right10">-->
<!--                    <Input v-model="search.min_yfee_qty" class="w150">-->
<!--                        <span slot="prepend">{{$t('yfee_xd')}} {{$t('xy_dy')}}</span>-->
<!--                    </Input>-->
<!--                </div>-->
<!--            </div>-->
            <div class="tree-box">
                <div v-for="(item, index) in listData" :key="index">
                    <Icon class="left-icon" type="ios-arrow-down" /><span>{{item.org_cname}} [ID:{{item.org_id}}] ({{$t('bal')}}{{item.money_amt}})</span>
                    <div class="pd-top10 pd-bottom10">
                        <span class="tag bg-grey" @click="openOrgAdmin(item.org_admin_code, item.org_id, item.org_cname)">{{$t("toggle_org_admin", [])}}</span>
                        <span class="tag bg-grey" @click="openAdmin(item.admin_code, item.org_id, item.org_cname)">{{$t("toggle_admin", [])}}</span>
                        <span class="tag error" @click="openHighSet(item)">{{$t("highset")}}</span>
                        <span class="tag warning" @click="openMsg(item)">{{$t("msg_mb")}}</span>
                        <span class="tag warning" @click="openSet(item)">{{$t("set_add")}}</span>
                        <span class="tag primary" @click="openSave(item)">{{$t("info")}}</span>
                        <span class="tag primary" @click="openAdd(item.org_cname, item.org_id, item.org_level)">{{$t("add_sub")}}</span>
                        <span class="tag primary" @click="openWxmpEwm(item.org_cname, item.org_id)">{{$t("wxm_ewm")}}</span>
                    </div>
                    <div class="sub-tree c1 f14">
                        <div class="sub-tree c2" v-for="(item2, k) in item.downs" :key="k">
                            <span class="f-blue">
                                <Icon class="left-icon" type="ios-arrow-down" />{{item2.org_cname}}
                                <span>[ID:{{item2.org_id}}] ({{$t('bal')}}{{item2.money_amt}})</span>
                            </span>
                            <div class="pd-top10 pd-bottom10">
                                <span class="tag bg-grey" @click="openOrgAdmin(item2.org_admin_code, item2.org_id, item2.org_cname)">{{$t("toggle_org_admin", [])}}</span>
                                <span class="tag bg-grey" @click="openAdmin(item2.admin_code, item2.org_id, item2.org_cname)">{{$t("toggle_admin", [])}}</span>
                                <span class="tag error" @click="openHighSet(item2)">{{$t("highset")}}</span>
                                <span class="tag warning" @click="openMsg(item2)">{{$t("msg_mb")}}</span>
                                <span class="tag warning" @click="openSet(item2)">{{$t("set_add")}}</span>
                                <span class="tag primary" @click="openSave(item2)">{{$t("info")}}</span>
                                <span class="tag primary" @click="openAdd(item2.org_cname, item2.org_id, item2.org_level)">{{$t("add_sub")}}</span>
                                <span class="tag primary" @click="openWxmpEwm(item2.org_cname, item2.org_id)">{{$t("wxm_ewm")}}</span>
                            </div>
                            <div class="sub-tree c3" v-for="(item3, kk) in item2.downs" :key="kk">
                                <span>
                                    <Icon type="ios-ionic" size="20" v-if="item3.org_status == '1'" class="f-green" />
                                    <Icon type="ios-ionic" size="20" v-else class="f-red" />
                                    {{item3.org_cname}}
                                    <span class="user-code-font">
                                        [ID:{{item3.org_id}}] ({{$t('bal')}}{{item3.money_amt}}) ({{$t('org_grade')}}{{$t('x_mh')}}<span class="f-red">{{item3.org_grade_cdesc}}</span>{{$t('x_fh')}}
                                        <span v-if="!$base.isEmpty(item3.date_to)">
                                            {{$t('bal_day_qty')}}{{$t('x_mh')}}
                                            <span class="f-red">{{item3.bal_day_qty}}{{$t('day')}}</span>{{$t('x_fh')}}
                                        </span>{{$t('exp_date')}}{{$t('x_mh')}}{{item3.date_to || $t('undefined')}})
                                    </span>
                                </span>
                                <div class="pd-top10 pd-bottom10">
                                    <span class="tag bg-grey" @click="openOrgAdmin(item3.org_admin_code, item3.org_id, item3.org_cname)">{{$t("toggle_org_admin", [])}}</span>
                                    <span class="tag bg-grey" @click="openAdmin(item3.admin_code, item3.org_id, item3.org_cname)">{{$t("toggle_admin", [])}}</span>
                                    <span class="tag error" @click="openHighSet(item3)">{{$t("highset")}}</span>
                                    <span class="tag warning" @click="openMsg(item3)">{{$t("msg_mb")}}</span>
<!--                                    <span class="tag warning" @click="openSet(item3)">{{$t("set_add")}}</span>-->
                                    <span class="tag primary" @click="openSave(item3)">{{$t("info")}}</span>
                                    <span class="tag primary" @click="openWxmpEwm(item3.org_cname, item3.org_id)">{{$t("wxm_ewm")}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <myNodata v-show="totalData.total <= 0" :last_time="search.search_time" style="width:100%;"></myNodata>
            </div>
            <div class="table-pager pd-top10 pd-bottom10" v-show="totalData.total > 0">
                <myPager :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </div>
        <Drawer class="drawer-sub-view" :title="sub_title" v-model="show_subview" width="850" :mask-closable="false" placement="left" :closable="false">
            <router-view></router-view>
        </Drawer>
    </div>
</template>

<script>
    import myPager from '../../../components/myPager'
    import myNodata from '../../../components/myNodata'
    import myDropdown from '../../../components/myDropdown'
    export default {
        name:'org-downs0',
        components:{
            myPager,
            myNodata,
            myDropdown
        },
        data:function(){
            return{
                title: this.$t('org_down'),
                export_title: '',
                sub_title:"",//子界面名称
                show_subview:false,
                relist:false,
                listData: [],
                search:{
                    search_url: "org-down-s0/list",
                    search_time: new Date(),//最新查询时间
                    org_from_cname: "", // 总店名称
                    org_from2_cname: "", // 区域名称
                    org_fr_cname: "",
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 5,
                    pageSize: 0,
                    min_money_amt_from: '',
                    min_money_amt_from2: '',
                    min_money_amt_fr: '',
                    min_msg_qty: '',
                    min_yfee_qty: ''
                },
                totalData: {
                    total: 0,//总行数
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.list();
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onSearchTextChange: function(data){
                this.list();
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            onLevelsChange:function () {
                this.list();
            },
            list: function (change_page) {
                if(!change_page) this.search.page = 1;
                this.search.search_time = new Date();
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data.list;
                        this.search.pageSize = parseInt(data.last_page);
                        this.totalData.total = data.total.total;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            openAdd:function (name, org_id, org_level) {
                this.sub_title = this.$t('add') +'('+ name +')';
                this.$base.linkTo('downs0/add', {org_id, org_level});
            },
            openSave:function (item) {
                this.sub_title = this.$t('upd') +'('+ item.org_cname +')';
                this.$base.linkTo('downs0/upd', {org_id: item.org_id, org_level: item.org_level});
            },
            openSet:function (item) {
                this.sub_title = this.$t('setup') +'('+ item.org_cname +')';
                this.$base.linkTo('downs0/setup', {org_id: item.org_id, data: JSON.stringify(item)});
            },
            openHighSet:function (item) {
                this.sub_title = this.$t('highset') +'('+ item.org_cname +')'
                this.$base.linkTo('downs0/higset', {data: JSON.stringify(item)});
            },
            openAdmin:function (admin_code, org_id, org_cname) {
                this.sub_title = this.$t('toggle_admin', [`(${org_cname})`]);
                this.$base.linkTo('downs0/admin', {admin_code, org_id});
            },
            openOrgAdmin:function (org_admin_code, org_id, org_cname) {
                this.sub_title = this.$t('toggle_org_admin', [`(${org_cname})`]);
                this.$base.linkTo('downs0/org_admin', {org_admin_code, org_id});
            },
            openMsg:function (item) {
                this.sub_title = this.$t('set_add') + ' ' + item.org_cname;
                this.$base.linkTo('downs0/msg',{org_id: item.org_id, org_level: item.org_level})
            },
            openWxmpEwm:function (org_cname, org_id,) {
                this.sub_title = this.$t('wxm_ewm');
                this.$base.linkTo('downs0/ewm',{org_id: org_id, org_cname: org_cname})
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(this.search.page);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>
    .tree-box{
        max-width: 1200px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/org/down/downs0.vue